import type { SVGProps } from 'react';
const DawnFlagSZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-SZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-SZ_svg__a)">
      <path
        fill="#486BCA"
        fillRule="evenodd"
        d="M0 3.2h22V0H0zM0 16h22v-3.2H0z"
        clipRule="evenodd"
      />
      <path fill="#FFDF20" fillRule="evenodd" d="M0 12.8h22V3.2H0z" clipRule="evenodd" />
      <path
        fill="#CF1615"
        fillRule="evenodd"
        d="M0 11.733h22V4.267H0z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 10.667c2.604 0 4.715-2.667 4.715-2.667S13.604 5.333 11 5.333 6.286 8 6.286 8s2.11 2.667 4.714 2.667"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-SZ_svg__b"
        width={10}
        height={6}
        x={6}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 10.667c2.604 0 4.715-2.667 4.715-2.667S13.604 5.333 11 5.333 6.286 8 6.286 8s2.11 2.667 4.714 2.667"
          clipRule="evenodd"
        />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-SZ_svg__b)">
        <path fill="#262626" d="M11.524 5.333H6.286v5.334h4.19z" />
        <path
          fill="#1A1A1A"
          d="M12.048 8.533c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .294.235.533.524.533"
        />
        <path
          fill="#F6F6F6"
          d="M9.953 8.533c.289 0 .523-.239.523-.533a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .294.234.533.524.533"
        />
      </g>
    </g>
  </svg>
);
export default DawnFlagSZ;
